import { render, staticRenderFns } from "./DissentInfo.vue?vue&type=template&id=7340dd9a&scoped=true&"
import script from "./DissentInfo.vue?vue&type=script&lang=js&"
export * from "./DissentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7340dd9a",
  null
  
)

export default component.exports